module.exports = "<template>\n    <b-field label=\"Select timepicker\">\n        <b-timepicker\n            placeholder=\"Type or select a date...\"\n            icon=\"clock\"\n            editable>\n        </b-timepicker>\n    </b-field>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/timepicker/examples/ExEditable.vue
// module id = 1560
// module chunks = 15